<div class="detail-page__rail-content" >
  <div class="section__right-rail">
    <div class="section__header">
      <h2 class="section__header-text">Awards and Recognitions</h2>
    </div>
    <div class="section__body" *ngIf="tagsToDisplay.length > 0 || oldTagsToDisplay.length > 0 || displayReportCard; else na">
      <ul class="awards-and-recognition__list">
        <li *ngFor="let awardTag of tagsToDisplay" class="awards-and-recognition__image-container">
          <img class="awards-and-recognition__image" src="{{getBadgeImageUrl(awardTag.tagName)}}" title="{{getAwardName(awardTag.tagName)}}">
        </li>
        <br *ngIf="tagsToDisplay.length > 0 && oldTagsToDisplay.length > 0">
        <li *ngFor="let awardTag of oldTagsToDisplay" class="awards-and-recognition__image-container">
          <img class="awards-and-recognition__image-old" src="{{getBadgeImageUrl(awardTag.tagName)}}" title="{{getAwardName(awardTag.tagName)}}">
        </li>
        <p *ngIf="displayReportCard" class="report-header">Customer Feedback Reports</p>
        <li *ngIf="displayReportCard" class="business-summary__report-image-container">
          <img class="awards-and-recognition__report-image" src="{{getReportCardBadgeUrl()}}" (click)="clickReportCard()">
        </li>
      </ul>
    </div>
  </div>
</div>
<ng-template #na>
  <span class="awards-and-recognition__message">
    Click
    <a href="https://aopa.org/training-and-safety/flight-schools/flight-training-initiative/flight-training-experience-survey-and-awards/flight-training-survey" target="_blank">
      HERE
    </a> to learn more about AOPA's Awards and Customer Feedback Program.
  </span>
</ng-template>
